import { render, staticRenderFns } from "./SupportTicketsCard.vue?vue&type=template&id=35f42562&scoped=true"
import script from "./SupportTicketsCard.vue?vue&type=script&lang=js"
export * from "./SupportTicketsCard.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketsCard.vue?vue&type=style&index=0&id=35f42562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f42562",
  null
  
)

export default component.exports